import { authApi } from './authApi';
import { IDraft } from '../interfaces/IDraft';
import { IObject } from '../interfaces/IObject';
import { IResponse } from '../interfaces/IResponse';

export const getDrafts = async (
  params: string
): Promise<IResponse<IDraft[]>> => {
  return await authApi.get(`draft/${params}`);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addDraft = async (payload: any) => {
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });
  return await authApi.post('draft/', formData);
};

export const getDocument = async (payload: IObject) => {
  return await authApi.post('azure/presigned-url/', payload);
};

export const getContractType = async (): Promise<IResponse<IObject[]>> => {
  return await authApi.get('admin/contract_type/');
};

export const getSections = async (draftId: string) => {
  return await authApi.get(`/draft/sections/${draftId}/`);
};

export const getInsights = async (draftId: string, fieldId: string) => {
  return await authApi.get(`/draft/insights/${draftId}/${fieldId}/`);
};
